import { render, staticRenderFns } from "./ChangePin.vue?vue&type=template&id=7a89a480&"
import script from "./ChangePin.vue?vue&type=script&lang=js&"
export * from "./ChangePin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports